import type {
  CreateProcessFolderRequest,
  UpdateProcessFolderRequest,
  ProcessFolderResponse,
  ProcessFoldersResponse,
  DeleteProcessFolderResponse,
} from "@/types/process-folder.types";
import { UtilsService } from "../utils";
import { authorizedAPI } from "@/config/axios.config";

const utils = new UtilsService();

class ProcessFolderService {
  // POST /process-folders - Create a new process folder
  async createProcessFolder(data: CreateProcessFolderRequest): Promise<ProcessFolderResponse> {
    return utils.handleApiRequest(() =>
      authorizedAPI.post("/process-folders", data)
    );
  }

  // GET /process-folders - Get all process folders
  async getAllProcessFolders(): Promise<ProcessFoldersResponse> {
    return utils.handleApiRequest(() => authorizedAPI.get("/process-folders"));
  }

  // GET /process-folders/{id} - Get a process folder by ID
  async getProcessFolderById(id: string): Promise<ProcessFolderResponse> {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/process-folders/${id}`)
    );
  }

  // PATCH /process-folders/{id} - Update a process folder
  async updateProcessFolder(
    id: string,
    data: UpdateProcessFolderRequest
  ): Promise<ProcessFolderResponse> {
    return utils.handleApiRequest(() =>
      authorizedAPI.patch(`/process-folders/${id}`, data)
    );
  }

  // DELETE /process-folders/{id} - Delete a process folder
  async deleteProcessFolder(id: string): Promise<DeleteProcessFolderResponse> {
    return utils.handleApiRequest(() =>
      authorizedAPI.delete(`/process-folders/${id}`)
    );
  }
}

export const processFolderService = new ProcessFolderService();

